import { render, staticRenderFns } from "./UsuarioFornecedorRepresentanteLegalForm.vue?vue&type=template&id=14874a0a&scoped=true&lang=html"
import script from "./UsuarioFornecedorRepresentanteLegalForm.vue?vue&type=script&lang=js"
export * from "./UsuarioFornecedorRepresentanteLegalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14874a0a",
  null
  
)

export default component.exports